import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from './MobilePhone.module.scss'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { Timer } from "../../../component/Timer/Timer";
import { PrivateQuestionList } from "../../../component/PrivateQuestionList/PrivateQuestionList";
import axios from "axios";

const data = [ 
    'In what city were you born', 
    'What is the name of your favorite pet', 
    "What is your mother's maiden name", 
    'What high school did you attend',
    'What is the name of your first school',
    'What was the make of your first car',
    'What was your favorite food as a child',
    'Where did you meet your spouse',
]

export const MobilePhone = () => {

    const phoneRegex = /^(\+)(\s*)?([- :]?\d[- :]?){7,12}$/
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
    const [mobilePhone, setMobilePhone] = useState('')
    const [PINCode, setPINCOde] = useState('')
    const [stage, setStage] = useState(1)
    const [erroeText, setErrorText] = useState('')
    const [isTimerVisible, setIstimerVisible] = useState(true)
    const [isDisabledButton, setDisabledButton] = useState(true)
    const [dropdownValue, setDropdownValue] = useState('')
    const [isDropdownVisible, setDropdownVisible] = useState(false)
    const [sequrityQuestionAnswer, setSequrityQuestionAnswer] = useState('')
    const [sequrityQuestionTip, setSequrityQuestionTip] = useState('')
    const [password, setPassword] = useState('')
    const [passwordSignIn, setPasswordSignIn] = useState('')
    const [passwordAgain, setPasswordAgain] = useState('')
    const navigate = useNavigate()
    const [idKyc, setIdKYC] = useState('')
    const envKycId :any = process.env.REACT_APP_KYC_ID


    const [send, setSend] = useState('1')


    const goBack= () => {
        setErrorText('')
        switch(stage){
            case 1: 
                navigate(-1)
                break;
            case 2:
                setStage(prev => prev - 1)
                setDisabledButton(false)
                break;
            case 3:
                setStage(prev => prev - 1)
                setDisabledButton(true)
                setSequrityQuestionAnswer('')
                setDropdownValue('')
                setSequrityQuestionTip('')
                break;
            case 4:
                setStage(prev => prev - 1)
                setDisabledButton(true)
                break;
        }
    }

    useEffect(() => {
        if(localStorage.getItem('token')){
            navigate('/')
        }
    },[])
    // 1

    useEffect(() => {
        if(mobilePhone && mobilePhone.length > 6){
            setDisabledButton(false)
        }
        else{
            setDisabledButton(true)
        }
    },[mobilePhone])

    const sendNotify = async (num:any) => {
        try{
            const request = await axios.post(`https://land.cpay.bar/sendNotify`, 
            {
                "phoneNumber": num,
            },
            {
                headers: {
                    "Content-Type": "application/json", 
                }
            }
            )
            console.log('notify', request)
            if(request.data.data.value.statusCode === 200) {
                // console.log('accept')
                setStage(prev => prev + 1)
            }
            else{
                setErrorText('Server error. Try again')
            }
        }
        catch(e){
            console.log(e)
        }
    }

    const isMobileExist = async (num:any) => {
        try{
            const request = await axios.post(`https://land.cpay.bar/getInfoByPhoneNumber`, 
            {
                "phoneNumber": num,
            },
            {
                headers: {
                    "Content-Type": "application/json", 
                }
            }
            )
            // console.log('phone',request)
            if(request.status === 200){
                // console.log('status 200');
                if(!request.data.data.value.registrationDone) { //регистрация не пройдена
                    // console.log('reg isnt completed');
                    if(!request.data.data.value.smsVerifyDone){ // отправлялась ли смс на телефон
                        // console.log('need send sms');
                        sendNotify(num)
                    }
                    else{
                        // console.log('shouldnt send sms');
                        setStage(prev => prev + 2)
                    }
                }
                else{
                    // console.log('reg is completed');
                    setStage(6)
                }
            }
            else if (request.status === 204) {
                sendNotify(num)
            }
            else{
                setErrorText('Something went wrong. Try again please!')
            }
        }
        catch(e){
            console.log(e)
        }
    }

    const sendSmsOnPhone = () => {
        const num = mobilePhone.replace('+', '')
        setDisabledButton(true)
        if(phoneRegex.test(mobilePhone)){
            // setStage(prev => prev + 1)
            isMobileExist(num)
        }
        else{
            setErrorText('Incorrect phone number')
        }
    }

    const setPhoneNumber = (e :any) => {
        setMobilePhone(e)
        setErrorText('')
    }

    // 2

    const onTimerFinish = () => {
        setIstimerVisible(false)
        setDisabledButton(true)
    }

    const resendCode = () => {
        setIstimerVisible(true)
        setDisabledButton(false)
    }
    const checkMobileSMS = async () => {
        const num = mobilePhone.replace('+', '')
        // const num = mobilePhone.replace('+', '')
        // if(PINCode === '123456'){
            // setPINCOde('')
            // setDisabledButton(true)
        //     setErrorText('')
        //     setStage(prev => prev + 1)
        // }
        // else{
        //     setErrorText('Incorrect SMS code')
        // }
        try{
            const request = await axios.post(`https://land.cpay.bar/checkVerifyCode`, 
            {
                "phoneNumber": num,
                "smsVerifyCode": PINCode
            },
            {
                headers: {
                    "Content-Type": "application/json", 
                }
            }
            )
            // console.log('check sms code',request)
            if(request.data.data.value){
                setStage(prev => prev + 1)
            }
            else{
                setErrorText('Incorrect sms code! Try one more time or resend code')
                setPINCOde('')
                setDisabledButton(true)
            }
        }
        catch(e){
            console.log(e)
        }
    }
    const inputSMSCode = (e :any) => {
        const value = e.target.value
        setErrorText('')
        if(value.length < 5){
            setPINCOde(value)
            setDisabledButton(true)
        }
        else if(value.length === 5){
            setPINCOde(value)
            setDisabledButton(false)
        }
        
    }

    //3 

    const handleDropdown = (value:any) => {
        setDropdownVisible(true)
        setDropdownValue(value)
    }

    const nextStageDropdown = () => {
        setDisabledButton(true)
        setStage(4)
        // console.log('drop down', dropdownValue, sequrityQuestionAnswer,sequrityQuestionTip)
    } 

    useEffect(() => {  
        if( sequrityQuestionAnswer && sequrityQuestionAnswer){
            setDisabledButton(false)
        }
        else{
            setDisabledButton(true)
        }
    },[sequrityQuestionAnswer, sequrityQuestionAnswer])

    // 4

    const setToken = async ()  => {
        const num = mobilePhone.replace('+', '')
        // const param = `?phoneNumber=${num}&password=${password}`
        try{
            const request = await axios.post(`https://land.cpay.bar/auth`, 
            {
                phoneNumber: num, 
                password: password
            },  
            {        
                headers: {
                    "Content-Type": "application/json", 
                    // "phoneNumber": num,
                    // "password": password,
                }
            }
            )
            // console.log('token', request.data.data.value)
            localStorage.setItem('token', request.data.data.value);
            setStage(prev => prev + 1)
        }
        catch(e) {

        }
    }

    const finishRegistration = async () => {
        const num = mobilePhone.replace('+', '')
        try{
            const request = await axios.post(`https://land.cpay.bar/registerFinal`, 
            {
                "password": password,
                "emailAddress": "",
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "phoneNumber": num,
                "dateOfBirth": "",
                "secret" : {
                    "question": dropdownValue,
                    "answer": sequrityQuestionAnswer,
                    "tip": sequrityQuestionTip
                }
            },
            {
                headers: {
                    "Content-Type": "application/json", 
                }
            }
            )
            // console.log('pass',password, "number", num, "question", dropdownValue , 'answer', sequrityQuestionAnswer, "tip", sequrityQuestionTip)
            // console.log('request', request);
            setToken()
        }
        catch(e){
            console.log(e)
        }
    }

    const nextStagePassword = () => {
        if(passwordRegex.test(password) && password === passwordAgain){
            finishRegistration()
            // setStage(5)
        }
        else if(password !== passwordAgain){
            setErrorText("Password doesn't match")
            setDisabledButton(true)
        }
        else{
            setErrorText('Password must contain minimum eight characters, at least one letter and one number')
            setDisabledButton(true)
        }
    }

    useEffect(() => {
        setErrorText('')
        if(password && passwordAgain){
            setDisabledButton(false)
        }
        else{
            setDisabledButton(true)
        }
    }, [password, passwordAgain])

    //5

    const finishSignUp = async () => {
        // console.log('here')
        try{
            const request = await axios.post("identifications/start", 
            {
                "requestData": {
                    "firstName": "Archi",
                    "lastName": "IName",
                    "emailAddress":"testv2@ondato.com",
                    "phoneNumber": "+12345678901",
                },
                "flowData": {
                    "language": "en"
                },
            }, 
            {headers: {'x-api-key': envKycId, "Content-Type": "application/json", "Access-Control-Allow-Origin" : "*", "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"}})
            setIdKYC(request.data.identificationId)
            // console.log('here',request.data)
        } 
        catch(e){
            console.log(e)
        }
    }

    const test = () => {
        window.open('https://sandbox-kyc.ondato.com/start/a0ddf10752df45ea8510a8e28241389a', 'Popup', 'width = 1000, height = 800')
    }

    const getTestData = async () => {
        // console.log('id', idKyc)
        try{
            const request = await axios.get(`identifications/405b8d960bd94e8ea108c6d663cf66e6/data`, 
            {
                headers: {
                'x-api-key': envKycId, 
                "Content-Type": "application/json", 
                "Access-Control-Allow-Origin" : "*", 
                "Access-Control-Allow-Headers" : "Origin, X-Requested-With, Content-Type, Accept"}
                }
            )
            // console.log('here',request.data)
        }
        catch(e){
            console.log(e)
        }
    }

    // 6

    useEffect(() => {
        setErrorText('')
        if(passwordSignIn){
            setDisabledButton(false)
        }
        else{
            setDisabledButton(true)
        }
    }, [passwordSignIn])

    const finishSignIn = async () => {
        const num = mobilePhone.replace('+', '')
        try{
            const request = await axios.post(`https://land.cpay.bar/auth`, 
            {
                phoneNumber: num, 
                password: passwordSignIn
            },  
            {        
                headers: {
                    "Content-Type": "application/json", 
                }
            }
            )
            // console.log('token', request)
            if(request.data.success){
                localStorage.setItem('token', request.data.data.value);
                navigate('/')
            }
            else{
                setErrorText('Password is incorrect. Try again')
            }
        }
        catch(e) {

        }
    }

    return(
        <div className={classes.mobile}>
            {/* <Link to="/signinCode">signUp mobile Phone - mobile prove code</Link> */}
            <div className={classes.mobile__logo}>
                <img alt='logo' src={require('../../../img/hugeLogo.png')} className={classes.mobile__logo_img}/>
            </div>
            <div className={classes.mobile__form}>
                <div className={classes.mobile__form_blur1}/>
                <div className={classes.mobile__form_blur2}/>
                <div className={classes.mobile__form_blur3}/>
                <img alt='go back' src={require('../../../img/back.png')} className={stage === 1 || stage === 2 ? classes.mobile__form_img : `${classes.mobile__form_img} ${classes.mobile__form_img_close}`} onClick = {goBack}/>
                { stage === 1 ?
                    <div className={classes.mobile__form__info}>
                        <p style={{opacity: 0}}>{erroeText}</p>
                        <p className={classes.mobile__form__info_step}>Step 1/4</p>
                        <p className={classes.mobile__form__info_title}>Account verification</p>
                        <p className={classes.mobile__form__info_descr}>Enter your phone number to let the system know if you are a new user or not</p>
                        <div className={classes.mobile__form__info_mobile}>
                            <PhoneInput 
                                placeholder="Enter phone number" 
                                value={mobilePhone} 
                                onChange = {e => setPhoneNumber(e)} 
                                defaultCountry="US"
                                className={classes.mobile__form__info_mobile_input}/>
                        </div>
                        <button className={classes.mobile__form__info_btn} disabled={isDisabledButton} onClick={sendSmsOnPhone}>Next</button>
                        <p className={classes.mobile__form__info_error}>{erroeText}</p>
                    </div>
                :
                    stage === 2 
                    ? 
                    <div className={classes.mobile__form__info}>
                        <p style={{opacity: 0}}>{erroeText}</p>
                        <p className={classes.mobile__form__info_step}>Step 2/4</p>
                        <p className={classes.mobile__form__info_title}>Verify phone number</p>
                        <p className={classes.mobile__form__info_descr}>Please enter the 5-digit SMS code that has been sent to <span>{mobilePhone}</span></p>
                        <div className={classes.mobile__form__info__password}>
                            <input 
                                value={PINCode}
                                onChange={(e) => inputSMSCode(e)}
                                placeholder={'Enter SMS code'}
                                className = {classes.mobile__form__info__password_input}
                            />
                        </div>
                        {isTimerVisible ?
                            <div className={classes.mobile__form__info__timer}>
                                <p className={classes.mobile__form__info__timer_title}>Resend code in</p>
                                <Timer seconds={120} onFinish={onTimerFinish}/>
                            </div>
                        :
                            <div className={`${classes.mobile__form__info__timer} ${classes.mobile__form__info__timer_active}`} onClick={resendCode}>
                                <p className={classes.mobile__form__info__timer_title}>Resend code</p>
                            </div>
                        }
                        <button className={classes.mobile__form__info_btn} disabled={isDisabledButton} onClick={checkMobileSMS}>Verify</button>
                        <p className={classes.mobile__form__info_error}>{erroeText}</p>
                    </div>
                    :

                    stage === 3 
                    ?
                    <div className={classes.mobile__form__info}>
                        <p style={{opacity: 0}}>{erroeText}</p>
                        <p className={classes.mobile__form__info_step}>Step 3/4</p>
                        <p className={classes.mobile__form__info_title}>Security question</p>
                        <p className={classes.mobile__form__info_descr}>Select the question and enter the answer with which you will be able to recover data</p>
                        <div className={classes.mobile__form__info__dropdown} onClick={() => setDropdownVisible(prev => !prev)}>
                            <input 
                                className={classes.mobile__form__info__dropdown_input}
                                value={dropdownValue}
                                placeholder='Pick security question'
                                onChange={() => {}} 
                                />
                            <img alt='show' src={require('../../../img/arrowDown.png')} className={classes.mobile__form__info__dropdown_img}/>
                            <PrivateQuestionList isVisible = {isDropdownVisible} onChangeValue = {handleDropdown}/>
                        </div>
                        <div className={classes.mobile__form__info__dropdownAnswer}>
                            <input 
                                placeholder='Answer'
                                value={sequrityQuestionAnswer}
                                onChange={(e) => setSequrityQuestionAnswer(e.target.value)}
                                className={classes.mobile__form__info__dropdownAnswer_input}
                            />
                        </div>
                        <div className={classes.mobile__form__info__dropdownTip}>
                            <input 
                                placeholder='Tip'
                                value={sequrityQuestionTip}
                                onChange={(e) => setSequrityQuestionTip(e.target.value)}
                                className={classes.mobile__form__info__dropdownTip_input}
                            />
                        </div>
                        <button className={classes.mobile__form__info_btn} disabled={isDisabledButton} onClick={nextStageDropdown}>Next</button>
                        <p className={classes.mobile__form__info_error}>{erroeText}</p>
                    </div>
                    :
                    stage === 4 
                    ?
                        <div className={classes.mobile__form__info}>
                            <p style={{opacity: 0}}>{erroeText}</p>
                            <p className={classes.mobile__form__info_step}>Step 4/4</p>
                            <p className={classes.mobile__form__info_title}>Password</p>
                            <p className={classes.mobile__form__info_descr}>Create your password to continue</p>
                            <div className={classes.mobile__form__info__password}>
                                <input 
                                    placeholder='Password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classes.mobile__form__info__password_input}
                                    type={'password'}
                                />
                            </div>
                            <div className={classes.mobile__form__info__againPassword}>
                                <input 
                                    placeholder='Again password'
                                    value={passwordAgain}
                                    onChange={(e) => setPasswordAgain(e.target.value)}
                                    className={classes.mobile__form__info__againPassword_input}
                                    type={'password'}
                                />
                            </div>
                            <button className={classes.mobile__form__info_btn} disabled={isDisabledButton} onClick={nextStagePassword}>Next</button>
                            <p className={classes.mobile__form__info_error}>{erroeText}</p>
                        </div>
                    :
                    stage === 5 ?
                    <div className={classes.mobile__form__info}>
                        <p style={{opacity: 0}}>{erroeText}</p>
                        <p className={classes.mobile__form__info_title}>Signed up successful completed!</p>
                        <p className={classes.mobile__form__info_descr}>Now tab the button and go to KYC check in order to fully use our product and make payments</p>
                        <button className={classes.mobile__form__info_btn} onClick={finishSignUp}>Take KYC check</button>
                        {/* <Link to="/" className={classes.mobile__form__info_link}>Take KYC check</Link> */}
                        <p className={classes.mobile__form__info_error}>{erroeText}</p>
                        <button className={classes.mobile__form__info_btn} onClick={test}>Test</button>
                        <button className={classes.mobile__form__info_btn} onClick={getTestData}>get data</button>
                    </div>
                    :
                    <div className={classes.mobile__form__info}>
                        <p style={{opacity: 0}}>{erroeText}</p>
                        <p className={classes.mobile__form__info_step}>Step 2/2</p>
                        <p className={classes.mobile__form__info_title}>Welcome back!</p>
                        <p className={classes.mobile__form__info_descr}>Sign In with a password to continue</p>
                        <div className={classes.mobile__form__info__password}>
                            <input 
                                placeholder='Password'
                                value={passwordSignIn}
                                onChange={(e) => setPasswordSignIn(e.target.value)}
                                className={classes.mobile__form__info__password_input}
                                type={'password'}
                            />
                        </div>
                        <button className={classes.mobile__form__info_btn} disabled={isDisabledButton} onClick={finishSignIn}>Sign in</button>
                        <p className={classes.mobile__form__info_error}>{erroeText}</p>
                    </div>
                }
            </div>
        </div>
    )
}